import { MyTeam } from "@/api/generated/backendAPI.schemas";

type Props = {
  team: MyTeam;
  startDatetime: string;
};

/**
 * 参加者本人のチーム。運営が組んだチームを知らせる。
 *
 * 開始日時より前は、自分以外のメンバーはイニシャルで届く（バックエンドが伏せる）。
 * 参加者どうしが事前に連絡を取り合わないようにするため。
 */
function MyTeamCard({ team, startDatetime }: Props) {
  return (
    <div className="mt-6 rounded-md border border-[#dbe1e6] bg-white px-5 py-4">
      <p className="text-[15px]">
        <span className="text-navcolor font-semibold">あなたのチーム：</span>
        <span className="font-bold text-[18px] ml-1">{team.teamName}</span>
      </p>
      <ul className="mt-2 flex flex-wrap gap-2">
        {team.members.map((member, i) => (
          <li
            key={member.userId ?? `masked-${i}`}
            className={
              "rounded-full px-3 py-1 text-[13px] " +
              (member.isMe
                ? "bg-subcolor text-white font-semibold"
                : "bg-gray-100 text-darkcolor")
            }
          >
            {member.name}
            {member.isMe && "（あなた）"}
          </li>
        ))}
      </ul>
      {!team.membersVisible && (
        <p className="mt-2 text-[13px] text-gray-500">
          メンバーの氏名は、開始日時（{new Date(startDatetime).toLocaleString()}
          ）から表示されます。
        </p>
      )}
    </div>
  );
}

export default MyTeamCard;
